// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"cb1eb0c9","580":"fca66de4","641":"37a463c6","798":"4618eb7e"}[chunkId] + ".chunk.js";
};